// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./blocks/shortcode/editor.scss
// module id = 54
// module chunks = 0